import React from 'react';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import { Box, IconButton, Link, Paper } from '@mui/material';


const instagramUrl = 'https://www.instagram.com/khangaroooo/';
const githubUrl = 'https://github.com/Khangaroooo';
const linkedInUrl = 'https://www.linkedin.com/in/khanghnguyen1999/';
const mailTo = 'mailto:nguyenh.khang.1999@gmail.com';

const Contact = () => {

    return (
        <React.Fragment>
            <Paper sx={{ padding: '1.5em', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} elevation={0.75}>
                <Box>Feel free to reach out!</Box>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap'}}>
                    <IconButton>
                        <InstagramIcon sx={{ width: '5em', height: '5em' }} onClick={() => {
                            window.open(instagramUrl, '_blank')
                        }} />
                    </IconButton>
                    <IconButton>
                        <LinkedInIcon sx={{ width: '5em', height: '5em' }} onClick={() => {
                            window.open(linkedInUrl, '_blank')
                        }} />
                    </IconButton>
                    <IconButton>
                        <GitHubIcon sx={{ width: '5em', height: '5em' }} onClick={() => {
                            window.open(githubUrl, '_blank')
                        }} />
                    </IconButton>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap:'wrap'}}>Or Email me at&nbsp;<Link onClick={() => {window.open(mailTo, '_blank')}}>nguyenh.khang.1999@gmail.com</Link ></Box>
            </Paper>
        </React.Fragment>
    );
}

export default Contact;
